<template>
  <ValidationObserver
      ref="observer"
      class="transition duration-500 ease-in-out transform w-full"
      style="transition: all 1s !important"
      tag="form"
      @submit.prevent="submit()"
  >
    <div class="lookup-form">
      <v-card class="mx-auto w-full lookup-form__card" flat max-height="auto" max-width="1000">
        <div class="lookup-form__grid flex flex-wrap my-2 mx-6 mb-4">
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Health Profession Name</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                  id="name"
                  v-model="formValues.name"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  name
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Health Profession Code</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                  id="code"
                  v-model="formValues.code"
                  :disabled="true"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  name
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Health Profession's Status</label
            >
            <validation-provider v-slot="{ errors }">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-switch
                      v-model="formValues.isActive"
                      color="green"
                      hide-details
                      v-on="on"
                  ></v-switch>
                </template>
                <span>{{ formValues.isActive == true ? 'Active' : 'Not Active' }}</span>
              </v-tooltip>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
        </div>
        <div class="lookup-form__actions">
          <v-btn class="lookup-form__cancel" text type="button" @click="$emit('close')">
            Cancel
          </v-btn>
          <v-btn
              :disabled="formValues.code === null"
              class="lookup-form__submit white--text"
              color="primary"
              depressed
              @click="submit()"
          >
            {{ formValues.editMode ? "Update" : "Add" }}
          </v-btn>
        </div>
      </v-card>
    </div>
  </ValidationObserver>
</template>

<script>
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {required} from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "This field is required",
});
export default {
  props: {
    healthProfession: Object,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      formValues: {
        name: "",
        code: null,
        isActive: true,
        editMode: false,
      },
      today: new Date().toISOString().substr(8, 11),
      disableAdd: true,
    };
  },
  created() {
    if (this.healthProfession != null) {
      this.formValues = this.healthProfession;
      this.formValues.editMode = true;
    }
  },
  methods: {
    async submit() {
      if (!(await this.$refs.observer.validate())) return;
      this.$refs.observer.validate();
      this.$emit("registerOrUpdateHealthProf", this.formValues);
      this.$emit("close");
    },
  },
  watch: {
    "formValues.name": function (event) {
      if (this.formValues.editMode !== true) {
        const tempEvent = event.toUpperCase();
        const subEventName = tempEvent.replace(/\s/g, "").substring(0, 3);
        const generatedCode =
            subEventName == null || subEventName == ""
                ? null
                : subEventName + `${this.today.replace(/\s+|T|:/g, "")}`;
        this.formValues.code = generatedCode
            ? generatedCode.replace(/-/g, "")
            : null;
      }
    },
  },
};
</script>

<style scoped>
.required > label::after {
  content: "*";
  color: red;
  padding-left: 3px;
}

input:disabled {
  background: #ccc;
}
</style>
